import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";

export function formatar_numeros_tabela_10(item: any) {
  return {
    ...item,
    quantidade: formatarNumero_recebido_com_casa_decimais(item.quantidade),
  };
}